import { combineReducers } from "redux";
import * as app from "../../containers/App";
import * as roomSelection from "../../containers/RoomSelection";
import * as checkout from "../../containers/Checkout";
import * as bookingConfirmation from "../../containers/BookingConfirmation";
import * as bookingModification from "../../containers/BookingModification";
import * as calendar from "../../components/Calendar";
import * as reservationManager from "../../containers/ReservationManager";
import intl from "~/redux/modules/intl";
import ui from "./ui";
import merge from "lodash/merge";
import { BOOKING_FORM_NAME_MOUNTPOINT } from "../../utils/constants";
import bookingFormReducer from "./bookingForm";

function entities(state = {}, action) {
  if (action && action.entities) {
    return merge({}, state, action.entities);
  }
  return state;
}

export default combineReducers({
  [BOOKING_FORM_NAME_MOUNTPOINT]: bookingFormReducer,
  [reservationManager.name]: reservationManager.reducer,
  [checkout.name]: checkout.reducer,
  [bookingConfirmation.name]: bookingConfirmation.reducer,
  [bookingModification.name]: bookingModification.reducer,
  [roomSelection.name]: roomSelection.reducer,
  [calendar.name]: calendar.reducer,
  [app.name]: app.reducer,
  restoredSession: (initial, action) => initial || {},
  entities,
  intl,
  ui,
});
